export default __webpack_public_path__ + "static/media/logoBlack.11f464d8.svg";